<template id="login-modal">
  <transition name="modal">

    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="wrapper">
            <button class="exit" @click="$store.commit('closeModal')" >
              x
            </button>

            <article class="not-loggedin" v-if="!$store.state.logged_in">
              <div v-if="loginToShow === 'login'">
                <FormLogin @loginType="typeChange"></FormLogin>
              </div>
              <div v-else-if="loginToShow === 'register'">
                <FormRegister @loginType="typeChange"></FormRegister>
              </div>
              <div v-else-if="loginToShow === 'forgot'">
                <FormForgot @loginType="typeChange"></FormForgot>
              </div>
            </article>

            <article class="loggedin" v-else>
              <div class="title">
                <h3>CAST YOUR VOTE</h3>
              </div>

              <img :src="image" class="hero">

              <button class="button" @click="doLike" v-if="!hasBeenLiked">
                Like this picture
              </button>
              <button class="button" @click="doUnlike" v-else >
                Unlike this picture
              </button>

              <p class="http-error" v-if="error">
                <i v-for="(err, index) in error" :key="index">{{ err }}</i>
              </p>
            </article>

          </div>

        </div>
      </div>
    </div>

  </transition>
</template>

<script>
import FormLogin from '@/components/FormLogin'
import FormRegister from '@/components/FormRegister'
import FormForgot from '@/components/FormForgot'

export default {
  components: {
    FormLogin, FormRegister, FormForgot
  },
  data () {
    return {
      loginToShow: 'login',
      error: null,
      hasBeenLiked: false,
      image: null
    }
  },
  mounted () {
    this.image = this.$store.state.modalsOpenPhoto
    if (this.$store.state.logged_in) {
      console.log(this.$store.state.modalsOpenId)
      let likeCheck = this.$store.state.config.user.what_i_like.find(item => item.id === this.$store.state.modalsOpenId)
      console.log(likeCheck)
      if (likeCheck) {
        this.hasBeenLiked = true
      }
    }
  },
  methods: {
    typeChange (type) {
      this.loginToShow = type
    },
    doLike () {
      this.error = null
      this.$http.likePic(this.$store.state.modalsOpenId)
        .then((res) => {
          if (res.status !== undefined) {
            console.log('like successful', this.$store.state.config.user)
            this.$emit('refreshGallery')
            this.$store.commit('closeModal')
          } else {
            console.log('inside error', res.response)
            this.error = res.response.data.errors
          }
        })
    },
    doUnlike () {
      this.error = null
      this.$http.unlikePic(this.$store.state.modalsOpenId)
        .then((res) => {
          if (res.status !== undefined) {
            console.log('unlike successful', this.$store.state.config.user)
            this.$emit('refreshGallery')
            this.$store.commit('closeModal')
          } else {
            console.log('inside error', res)
            this.error = res.response.data.errors
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";

.not-loggedin {
  .button-cta {
    margin: 5px;
  }
}
.loggedin {
  text-align: center;
  .title h3 {
    border-bottom: none !important;
  }
  .button {
    width: auto;
    margin: 40px 5px 0;
  }

  .http-error {
    margin: 20px 0 0;
    padding: 5px 10px;
  }
}
</style>
